import type {
    AnatomySampleMap
} from "../types";
import {
    HighlightButton,
    PaletteSwitcher,
    LocaleSwitcher,
    ThemeSwitcher,
    ToggleGroup,
    ButtonGroup,
    Button,
    Toggle
} from "ncore-ui-kit";
import {
    HeartIcon,
    PlusIcon,
    HomeIcon,
    StarIcon
} from "../icons";

export const actionSamples: AnatomySampleMap = {
    Toggle: (t) => ({
        states: [
            {
                node: <Toggle
                    title={t("sample.label")}
                    variant="outline"
                    isPressed={false}
                    icon={StarIcon}
                />,
                label: t("sample.stateOff")
            },
            {
                node: <Toggle
                    title={t("sample.label")}
                    variant="outline"
                    isPressed={true}
                    icon={StarIcon}
                />,
                label: t("sample.stateOn")
            }
        ]
    }),
    ToggleGroup: (t) => ({
        node: <ToggleGroup
            attachBehaviour="attached"
            title={t("sample.label")}
            defaultValue="first"
            variant="outline"
        >
            <ToggleGroup.Item
                title={t("sample.option1")}
                isIconOnly={true}
                icon={HomeIcon}
                value="first"
            />
            <ToggleGroup.Item
                title={t("sample.option2")}
                isIconOnly={true}
                icon={StarIcon}
                value="second"
            />
            <ToggleGroup.Item
                title={t("sample.option3")}
                isIconOnly={true}
                icon={HeartIcon}
                value="third"
            />
        </ToggleGroup>
    }),
    ButtonGroup: (t) => ({
        node: <ButtonGroup
            title={t("sample.label")}
            variant="tonal"
        >
            <Button
                title={t("sample.item1")}
                onPress={() => undefined}
            />
            <ButtonGroup.Separator />
            <Button
                title={t("sample.item2")}
                onPress={() => undefined}
            />
            <ButtonGroup.Separator />
            <Button
                title={t("sample.item3")}
                onPress={() => undefined}
            />
        </ButtonGroup>
    }),
    Button: (t) => ({
        node: <Button
            title={t("sample.action")}
            onPress={() => undefined}
            icon={PlusIcon}
        />
    }),
    HighlightButton: (t) => ({
        node: <HighlightButton
            title={t("sample.action")}
            onPress={() => undefined}
            icon={PlusIcon}
            type="primary"
        />
    }),
    LocaleSwitcher: () => ({
        node: <LocaleSwitcher
            isShowTitle={true}
        />
    }),
    PaletteSwitcher: () => ({
        node: <PaletteSwitcher
            isShowTitle={true}
        />
    }),
    ThemeSwitcher: () => ({
        node: <ThemeSwitcher
            isShowTitle={true}
        />
    })
};
